// Reconstructed from the supplied production build; original component names were unavailable.
import { useAuth } from "../context/AuthContext.jsx";
import { React, useLocation, useNavigate } from "../vendor/runtime.js";
import { AuthLayout } from "../components/auth/AuthLayout.jsx";
import { LoginForm } from "../components/auth/LoginForm.jsx";
import { Toast } from "../components/Toast.jsx";
const LoginPage = () => {
  var f;
  const { currentUser: a } = useAuth(),
    n = useNavigate(),
    i = useLocation(),
    l = (f = i.state) == null ? undefined : f.verificationSuccess,
    [c, u] = React.useState(false);
  (React.useEffect(() => {
    a && n("/products");
  }, [a, n]),
    React.useEffect(() => {
      if (l) {
        u(true);
        const x = setTimeout(() => {
          u(false);
        }, 4e3);
        return () => clearTimeout(x);
      }
    }, [l]));
  const m = () => {
    var x;
    (u(false),
      (x = i.state) != null &&
        x.verificationSuccess &&
        n(i.pathname, {
          replace: true,
          state: {},
        }));
  };
  return (
    <AuthLayout>
      <LoginForm />
      <Toast show={c} onClose={m} message={"Email verified successfully! You can now log in."} />
    </AuthLayout>
  );
};
export { LoginPage };
